import React, {useState, useContext} from 'react';
import { IonLabel, IonInput, IonCol, IonRow, IonDatetime } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

export function SelectDateRange_CheckIn(props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    let [startDateRange, setStartDateRange] = useState(new Date());
    let [endDateRange, setEndDateRange] = useState(new Date());
    let [dateRangeNumberOfNights, setDateRangeNumberOfNights] = useState(0);

    /*let [startMonth, setStartMonth] = useState(null);
    let [startDay, setStartDay] = useState(null);
    let [startYear, setStartYear] = useState(null);

    let [endMonth, setEndMonth] = useState(null);
    let [endDay, setEndDay] = useState(null);
    let [endYear, setEndYear] = useState(null);*/
    //let startMonth = startDateRange.toLocaleString('en-us', {month: 'long'});
    //let startDay = startDateRange.toLocaleString('en-us', {day: '2-digit'});
    //let startYear = startDateRange.getFullYear();

    //let endMonth = endDateRange.toLocaleString('en-us', {month: 'long'});
    //let endDay = endDateRange.toLocaleString('en-us', {day: '2-digit'});
    //let endYear = endDateRange.getFullYear();

    function handleSelectStartDateRange(e) { 
        
       //alert('In handleSelectStartDateRange');
        //alert(e[0]);
        //alert(endDateRange);

        //setStartDateRange(new Date(e.target.value));    
        setStartDateRange(e[0]);    

        let date1 = new Date(e[0]);
        let date2 = new Date(new Date(endDateRange));
        let timeDiff = Math.abs(date2.getTime() - date1.getTime());
        let calcNumberOfNights = Math.ceil(timeDiff / (1000 * 3600 * 24)); 

        //setStartMonth(new Date(e.target.value).toLocaleString('en-us', {month: 'long'}));
        //setStartDay(new Date(e.target.value).toLocaleString('en-us', {day: '2-digit'}));
        //setStartYear(new Date(e.target.value).getFullYear());
        setDateRangeNumberOfNights(calcNumberOfNights)

        props.onCheckInDate({startDate: e[0].toISOString().substr(0, 10), endDate: endDateRange.toISOString().substr(0, 10), numOfNights: calcNumberOfNights});
    }

    function handleSelectEndDateRange(e) {   
       //alert('In handleSelectEndDateRange');
         /*alert(endDateRange);
        alert(endMonth);
        alert(e.target.value);*/

        //setEndDateRange(new Date(e.target.value));
        setEndDateRange(e[1]);

        let date1 = new Date(new Date(startDateRange));
        let date2 = new Date(e[1]);
        let timeDiff = Math.abs(date2.getTime() - date1.getTime());
        let calcNumberOfNights = Math.ceil(timeDiff / (1000 * 3600 * 24)); 


        //setEndMonth(new Date(e.target.value).toLocaleString('en-us', {month: 'long'}));
        //setEndDay(new Date(e.target.value).toLocaleString('en-us', {day: '2-digit'}));
        //setEndYear(new Date(e.target.value).getFullYear());
        setDateRangeNumberOfNights(calcNumberOfNights);

        props.onCheckInDate({startDate: startDateRange.toISOString().substr(0, 10), endDate: e[1].toISOString().substr(0, 10), numOfNights: calcNumberOfNights});
    }

    return (

        <React.Fragment>
            <IonRow>
                <IonCol size='4'>
                    <h5>CHECK-IN</h5>
                   {/* {authenticatedMerchent_context.device == 'mobile' && <IonDatetime displayFormat='MMM DD, YYYY' placeholder={startDateRange.toLocaleString('en-us', {month: 'short', day: '2-digit'})+', '+startDateRange.getFullYear()} onIonChange={(e) => handleSelectStartDateRange([new Date(e.target.value), endDateRange])}>  </IonDatetime> }*/}
                   {authenticatedMerchent_context.device == 'mobile'&&  <IonInput type='date' value={startDateRange.toISOString().substr(0, 10)} onIonChange={(e)=> handleSelectStartDateRange([new Date(e.target.value), endDateRange])}>  </IonInput>  }

                    {(authenticatedMerchent_context.device == 'desktop' || authenticatedMerchent_context.device == null) &&  <IonInput type='date' value={startDateRange.toISOString().substr(0, 10)} onIonChange={(e)=> handleSelectStartDateRange([new Date(e.target.value), endDateRange])}>  </IonInput>  }
                </IonCol>
                <IonCol size='4'>
                    <h5>Nights: </h5>
                    <p>{dateRangeNumberOfNights}</p>
                </IonCol>
                <IonCol size='4'>
                    <h5>CHECK-OUT</h5>
                   {/* {authenticatedMerchent_context.device == 'mobile' && <IonDatetime displayFormat='MMM DD, YYYY' placeholder={endDateRange.toLocaleString('en-us', {month: 'short', day: '2-digit'})+', '+endDateRange.getFullYear()} onIonChange={(e) => handleSelectEndDateRange([startDateRange, new Date(e.target.value)])}>  </IonDatetime> } */}
                   {authenticatedMerchent_context.device == 'mobile' &&  <IonInput type='date' value={endDateRange.toISOString().substr(0, 10)} onIonChange={(e)=> handleSelectEndDateRange([startDateRange, new Date(e.target.value)])}>  </IonInput>  }

                    {(authenticatedMerchent_context.device == 'desktop' || authenticatedMerchent_context.device == null) &&  <IonInput type='date' value={endDateRange.toISOString().substr(0, 10)} onIonChange={(e)=> handleSelectEndDateRange([startDateRange, new Date(e.target.value)])}>  </IonInput>  }
                </IonCol>
            </IonRow>
           {/*} <IonRow>
                <IonCol style={{ fontSize: ".5em !important"}}>
                    {authenticatedMerchent_context.device == 'mobile' && <IonDatetime displayFormat='MMM DD, YYYY' placeholder={startDateRange.toLocaleString('en-us', {month: 'short', day: '2-digit'})+', '+startDateRange.getFullYear()} onIonChange={(e) => handleSelectStartDateRange([new Date(e.target.value), endDateRange])}>  </IonDatetime> }
                    {authenticatedMerchent_context.device == 'desktop' &&  <IonInput type='date' value={startDateRange.toISOString().substr(0, 10)} onIonChange={(e)=> handleSelectStartDateRange([new Date(e.target.value), endDateRange])}>  </IonInput>  }
                </IonCol>
                <IonCol style={{ fontSize: ".5em !important"}}>
                    <p>{dateRangeNumberOfNights}</p>
                </IonCol>
                <IonCol>                    
                    {authenticatedMerchent_context.device == 'mobile' && <IonDatetime displayFormat='MMM DD, YYYY' placeholder={endDateRange.toLocaleString('en-us', {month: 'short', day: '2-digit'})+', '+endDateRange.getFullYear()} onIonChange={(e) => handleSelectEndDateRange([startDateRange, new Date(e.target.value)])}>  </IonDatetime> } 
                    {authenticatedMerchent_context.device == 'desktop' &&  <IonInput type='date' value={endDateRange.toISOString().substr(0, 10)} onIonChange={(e)=> handleSelectEndDateRange([startDateRange, new Date(e.target.value)])}>  </IonInput>  }
                </IonCol>
            </IonRow>*/}
        </React.Fragment>
        /*<React.Fragment>
            <IonRow>
                <IonCol>
                    <IonLabel for='startDateRange'>Start: </IonLabel>
                    <IonInput type='date' id='startDateRange' onIonChange={handleSelectStartDateRange}>
                    </IonInput>
                    <div>{startMonth+ ' '+startDay+', '+startYear}</div>
                </IonCol>
                <IonCol>
                    <IonLabel for='endDateRange'>End: </IonLabel>
                    <IonInput type='date' id='endDateRange' onIonChange={handleSelectEndDateRange}>
                    </IonInput>
                    <div>{endMonth+ ' '+endDay+', '+endYear}</div>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    <IonLabel># of Nights: </IonLabel>
                    <p>{dateRangeNumberOfNights}</p>
                </IonCol>
            </IonRow>
        </React.Fragment>*/
    )

}